import { render, staticRenderFns } from "./CandidatesSync.vue?vue&type=template&id=3fefb5a7&lang=pug"
import script from "./CandidatesSync.vue?vue&type=script&lang=js"
export * from "./CandidatesSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports